<nav class="navbar">
  <div class="navbar-inner">
    <!-- Logo -->
    <a routerLink="/" class="navbar-logo">
      <div class="logo-icon">
        <i class="fas fa-graduation-cap"></i>
      </div>
      <span class="logo-text">Skill<span style="color:var(--sb-primary)">Bridge</span></span>
    </a>

    <!-- Desktop nav links -->
    <div class="navbar-links">
      <a routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}" class="nav-link">Home</a>
      <a routerLink="/courses" routerLinkActive="active" class="nav-link">Courses</a>
      <a routerLink="/sessions" routerLinkActive="active" class="nav-link">Sessions</a>
    </div>

    <!-- Desktop auth actions -->
    <div class="navbar-actions">
      @if (auth.isLoggedIn()) {
        <a [routerLink]="dashboardRoute" class="nav-link">Dashboard</a>
        <div class="user-avatar-wrap" [matMenuTriggerFor]="userMenu">
          <img [src]="auth.currentUser()?.avatarUrl" [alt]="auth.currentUser()?.name" class="user-avatar" />
          <span class="user-name">{{ auth.currentUser()?.name }}</span>
        </div>
        <mat-menu #userMenu="matMenu">
          <button mat-menu-item [routerLink]="dashboardRoute">Dashboard</button>
          <button mat-menu-item (click)="logout()">Logout</button>
        </mat-menu>
      } @else {
        <a routerLink="/login" class="nav-link-secondary">Login</a>
        <a routerLink="/register" class="btn-primary">Get Started Free</a>
      }
    </div>

    <!-- Mobile burger -->
    <button class="burger-btn" (click)="mobileOpen = !mobileOpen" aria-label="Toggle menu">
      <i class="fas fa-bars"></i>
    </button>
  </div>

  <!-- Mobile drawer -->
  @if (mobileOpen) {
    <div class="mobile-menu">
      <a routerLink="/" class="mobile-link" (click)="mobileOpen=false">Home</a>
      <a routerLink="/courses" class="mobile-link" (click)="mobileOpen=false">Courses</a>
      <a routerLink="/sessions" class="mobile-link" (click)="mobileOpen=false">Live Sessions</a>
      @if (auth.isLoggedIn()) {
        <a [routerLink]="dashboardRoute" class="mobile-link" (click)="mobileOpen=false">Dashboard</a>
        <button class="mobile-link" style="background:none;border:none;text-align:left;color:inherit;cursor:pointer;padding:10px 0;" (click)="logout(); mobileOpen=false">Logout</button>
      } @else {
        <div style="display:flex;flex-direction:column;gap:8px;margin-top:8px;">
          <a routerLink="/login" class="btn-outline-dark" (click)="mobileOpen=false">Login</a>
          <a routerLink="/register" class="btn-primary" style="justify-content:center;" (click)="mobileOpen=false">Get Started Free</a>
        </div>
      }
    </div>
  }
</nav>
